import {
    BlockOutlined,
    CodepenOutlined,
    ContainerOutlined,
    GroupOutlined,
    ImportOutlined,
    KeyOutlined,
    PaperClipOutlined,
    PlaySquareOutlined,
    ReadOutlined,
    TagOutlined,
    TagsOutlined,
    TeamOutlined,
    WechatOutlined,
    FieldTimeOutlined,
    AccountBookOutlined,
    ShoppingCartOutlined,
    RollbackOutlined,
    SafetyOutlined,
    BarChartOutlined,
} from '@ant-design/icons';
import { ErrorComponent, notificationProvider, ReadyPage } from '@pankod/refine-antd';
import '@pankod/refine-antd/dist/styles.min.css';
import { Refine } from '@pankod/refine-core';
import routerProvider from '@pankod/refine-react-router-v6';
import { Footer, Header, Layout, OffLayoutArea, Sider, Title } from 'components/layout';
import CustomDataProvider from 'dataProvider';
import { CrateCreate, CrateEdit, CrateList } from 'pages/crates';
import { GenreCreate, GenreEdit, SlugList } from 'pages/genres';
import { LabelCreate, LabelEdit, LabelList } from 'pages/labels';
import { Login } from 'pages/login';
import { SubscriptionPackageCreate, SubscriptionPackageEdit, SubscriptionPackageList } from 'pages/subscriptionPackages';
import { ReleaseCreate, ReleaseEdit, ReleaseList, ReleasePurchaseShow } from 'pages/releases';
import { RequestList, RequestShow } from 'pages/requests';
import { SampleCreate, SampleEdit, SampleList } from 'pages/samples';
import { TagCreate, TagEdit, TagList } from 'pages/tags';
import { TrackEdit, TrackList } from 'pages/tracks';
// import { TransactionEdit, TransactionList } from "pages/transactions";
import { UserEdit, UserList } from 'pages/users';

// import { AdminDashboard } from "pages/adminDashboard";
import { ImportData } from 'pages/importData';
// import { PlaylistCreate, PlaylistEdit, PlaylistList } from "pages/playlist";
// import { SiteDesign } from "pages/siteDesign/edit";
import { TrackKeyCreate, TrackKeyEdit, TrackKeyList } from 'pages/track-key';
import { TrackPurchaseEdit, TrackPurchaseList } from 'pages/trackPurchases';
import { useTranslation } from 'react-i18next';
import { authProvider } from 'services/authProvider';
import axiosService from 'services/axios.service';
import { QuestionList, QuestionShow } from 'pages/questions';
import { TransactionSubscriptionsList } from 'pages/subscriptionTransactions';
// import { ContributorSubscriptionPurchaseList } from "pages/contributorSubscriptionPurchase/list";
// import { BannerEdit, BannersCreate, BannersList } from "pages/banner";
import { OrdersList } from 'pages/orders';
import { AccountingList } from 'pages/accounting';
import { DraftTrackEdit, DraftTracksList } from 'pages/drafts';
import { OrderShow } from 'pages/orders/show';
import { OptionReleasePricingCreate, OptionReleasePricingEdit, OptionReleasePricingList } from 'pages/releasePricing';
import { PageHeaders } from 'pages/page/list';
import { AdsList } from 'pages/ads/list';

import { DisputeEdit, DisputeList } from 'pages/disputes';
import { DiscountsMultipack } from 'pages/discountMultipacks';
import { DiscountsTrack } from 'pages/discountTracks';
import { QuestionEdit } from 'pages/questions/edit';
import { AdsEdit } from 'pages/ads';
import { JobPage } from 'pages/job/list';
import { JobEdit } from 'pages/job/edit';
import { SubscriptionPackagePurchasesShow } from 'pages/subscriptionTransactions/show';
import { TrackPurchasesDlShow } from 'pages/accounting/show';
import { WatermarkVerify } from 'pages/watermark';
import { AnalyticsList } from 'pages/adminDashboard/analytics/list';
import { SubscriptionReconciliationList } from 'pages/subscriptionTransactions/reconciliation';


function App() {
    const API_URL = process.env.REACT_APP_URL_API;
    const BASE_API_URL = `${API_URL}/v1/admin`;
    const { t, i18n } = useTranslation();

    const i18nProvider = {
        translate: (key: string, params: object) => t(key, params),
        changeLocale: (lang: string) => i18n.changeLanguage(lang),
        getLocale: () => i18n.language,
    };

    return (
        <Refine
            authProvider={authProvider}
            routerProvider={routerProvider}
            dataProvider={CustomDataProvider(BASE_API_URL, axiosService.service as any)}
            notificationProvider={notificationProvider}
            ReadyPage={ReadyPage}
            catchAll={<ErrorComponent />}
            LoginPage={Login}
            resources={[
                // {
                //   name: "dashboard",
                //   list: AdminDashboard,
                //   icon: <GlobalOutlined />,
                // },
                // {
                //   name: "settings",
                //   list: SiteDesign,
                //   icon: <BgColorsOutlined />,
                // },

                {
                    name: 'users',
                    list: UserList,
                    // create: UserCreate,
                    edit: UserEdit,
                    icon: <TeamOutlined />,
                },
                {
                    name: 'tracks',
                    list: TrackList,
                    edit: TrackEdit,
                    icon: <PlaySquareOutlined />,
                },
                {
                    name: 'ads',
                    list: AdsList,
                    edit: AdsEdit,
                    icon: <CodepenOutlined />,
                },
                {
                    name: 'job',
                    list: JobPage,
                    edit: JobEdit,
                    icon: <CodepenOutlined />,
                },
                {
                    name: 'track-purchases',
                    list: TrackPurchaseList,
                    edit: TrackPurchaseEdit,
                    icon: <ContainerOutlined />,
                },
                {
                    name: 'orders',
                    list: OrdersList,
                    show: OrderShow,
                    icon: <ShoppingCartOutlined />,
                },
                {
                    name: 'accounting-period',
                    list: AccountingList,
                    show: TrackPurchasesDlShow,
                    icon: <PaperClipOutlined />,
                },
                {
                    name: 'analytics',
                    list: AnalyticsList,
                    icon: <BarChartOutlined />,
                },
                {
                    name: 'drafts',
                    list: DraftTracksList,
                    edit: DraftTrackEdit,
                    icon: <PlaySquareOutlined />,
                },
                // {
                //   name: "playlists",
                //   list: PlaylistList,
                //   create: PlaylistCreate,
                //   edit: PlaylistEdit,
                //   icon: <ProjectOutlined />,
                // },
                {
                    name: 'multipacks',
                    list: ReleaseList,
                    create: ReleaseCreate,
                    edit: ReleaseEdit,
                    show: ReleasePurchaseShow,
                    icon: <ReadOutlined />,
                },
                {
                    name: 'track-Keys',
                    list: TrackKeyList,
                    create: TrackKeyCreate,
                    edit: TrackKeyEdit,
                    icon: <KeyOutlined />,
                },
                {
                    name: 'tags',
                    list: TagList,
                    create: TagCreate,
                    edit: TagEdit,
                    icon: <TagOutlined />,
                },
                // {
                //   name: "token-packages",
                //   list: TokenPackageList,
                //   create: TokenPackageCreate,
                //   edit: TokenPackageEdit,
                //   icon: <MoneyCollectOutlined />,
                // },
                // {
                //   name: "token-package-purchases",
                //   list: TransactionPackagesList,
                //   icon: <CodepenOutlined />,
                // },
                {
                    name: 'subscription-packages',
                    list: SubscriptionPackageList,
                    create: SubscriptionPackageCreate,
                    edit: SubscriptionPackageEdit,
                    icon: <FieldTimeOutlined />,
                },
                {
                    name: 'subscription-package-purchases',
                    list: TransactionSubscriptionsList,
                    show: SubscriptionPackagePurchasesShow,
                    icon: <CodepenOutlined />,
                },
                {
                    name: 'subscription-reconciliation',
                    list: SubscriptionReconciliationList,
                    icon: <SafetyOutlined />,
                },
                // {
                //     name: 'token-count',
                //     list: TokenValueList,
                //     icon: <PayCircleOutlined />,
                // },
                // {
                //     name: 'contributor-subscription-pool',
                //     list: ContributorSubscriptionPoolList,
                //     icon: <PayCircleOutlined />,
                // },
                // {
                //   name: "contributor-subscription-downloads",
                //   list: ContributorSubscriptionPurchaseList,
                //   icon: <PayCircleOutlined />,
                // },
                {
                    name: 'labels',
                    list: LabelList,
                    create: LabelCreate,
                    edit: LabelEdit,
                    icon: <TagsOutlined />,
                },
                // TODO: Will enable later
                // {
                //   name: "banners",
                //   list: BannersList,
                //   edit: BannerEdit,
                //   create: BannersCreate,
                //   icon: <CarryOutOutlined />,
                // },
                {
                    name: 'genres',
                    list: SlugList,
                    create: GenreCreate,
                    edit: GenreEdit,
                    icon: <PaperClipOutlined />,
                },
                {
                    name: 'crates',
                    list: CrateList,
                    create: CrateCreate,
                    edit: CrateEdit,
                    icon: <GroupOutlined />,
                },
                {
                    name: 'samples',
                    list: SampleList,
                    create: SampleCreate,
                    edit: SampleEdit,
                    icon: <BlockOutlined />,
                },
                // {
                //   name: "transactions",
                //   list: TransactionList,
                //   edit: TransactionEdit,
                //   icon: <DollarOutlined />,
                // },
                {
                    name: 'requests',
                    list: RequestList,
                    show: RequestShow,
                    icon: <WechatOutlined />,
                },
                {
                    name: 'questions',
                    list: QuestionList,
                    edit: QuestionEdit,
                    show: QuestionShow,
                    icon: <WechatOutlined />,
                },

                {
                    name: 'import-data',
                    list: ImportData,
                    icon: <ImportOutlined />,
                },
                {
                    name: 'disputes',
                    list: DisputeList,
                    edit: DisputeEdit,
                    icon: <RollbackOutlined />,
                },
                {
                    name: 'discountsTracks',
                    list: DiscountsTrack,
                    icon: <AccountBookOutlined />,
                },
                {
                    name: 'discountsMultipacks',
                    list: DiscountsMultipack,
                    icon: <AccountBookOutlined />,
                },
                // {
                //   name: "subscription-applications",
                //   list: SubscriptionApplicationsList,
                //   show: SubscriptionApplicationsShow,
                //   icon: <CarryOutOutlined />,
                // },
                {
                    name: 'release-pricing',
                    list: OptionReleasePricingList,
                    create: OptionReleasePricingCreate,
                    edit: OptionReleasePricingEdit,
                    icon: <FieldTimeOutlined />,
                },
                {
                    name: 'watermark',
                    list: WatermarkVerify,
                    icon: <SafetyOutlined />,
                },
                {
                    name: 'page',
                    list: PageHeaders,
                    icon: <CodepenOutlined />,
                },
            ]}
            Title={Title}
            Header={Header}
            Sider={Sider}
            Footer={Footer}
            Layout={Layout}
            OffLayoutArea={OffLayoutArea}
            i18nProvider={i18nProvider}
        />
    );
}

export default App;
